import { useEffect } from 'react';

import { useIntl } from '../../util/reactIntl';
import { normalizeLocale, writeLocaleCookie } from '../../util/locale';

const GUARD_KEY = 'sihmo_lang_synced';

/**
 * Renders nothing. A signed-in user's saved language follows them to other
 * devices: if the profile says "de" but this browser shows something else, take
 * over the saved language once and reload. A session flag keeps this from
 * looping when cookies are blocked.
 */
const LocaleSync = props => {
  const { currentUser } = props;
  const intl = useIntl();
  const saved = normalizeLocale(currentUser?.attributes?.profile?.publicData?.locale);
  const current = normalizeLocale(intl.locale) || 'en';

  useEffect(() => {
    if (!saved || saved === current) {
      return;
    }
    try {
      if (window.sessionStorage.getItem(GUARD_KEY)) {
        return;
      }
      window.sessionStorage.setItem(GUARD_KEY, '1');
    } catch (e) {
      return; // can't guard against a reload loop -> don't reload
    }
    writeLocaleCookie(saved);
    window.location.reload();
  }, [saved, current]);

  return null;
};

export default LocaleSync;
